<template>
  <div class="manager-flex">
    <div class="pages--top-flex">
      <div class="header flex-between">
        <div class="header-text">
          <h1>大客户经理</h1>
        </div>
        <div class="header-button">
          <el-button
            v-if="jurisdiction.search"
            icon="iconfont icon-sousuo1"
            @click="Query"
            >查询</el-button
          >
          <el-button
            v-if="jurisdiction.create"
            icon="iconfont icon-chuangjian1"
            @click="create"
            >创建</el-button
          >

          <el-button
            v-if="jurisdiction.edit"
            icon="iconfont icon-xiugai1"
            @click="modify"
            >修改</el-button
          >
          <el-button
            v-if="jurisdiction.delete"
            icon="iconfont icon-a-shanchu11"
            @click="Delete"
            >删除</el-button
          >
          <el-button
            v-if="jurisdiction.look"
            icon="iconfont icon-chakan1"
            @click="lookOver"
            >查看</el-button
          >
        </div>
      </div>
      <el-card shadow="never">
        <div class="searchform">
          <el-form size="small" label-width="120px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="大客户经理名称">
                  <el-input v-model="Pages.search"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="维护店">
                  <el-select
                    style="width: 100%"
                    v-model="MaintenanceAreaSelect"
                  >
                    <el-option
                      v-for="item in MaintenanceArea"
                      :key="item.id"
                      :label="item.lable"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
               <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    style="width: 100%"
                    v-model="Pages.state"
                  >
                    <el-option
                      v-for="item in stateList"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="centercard">
      <el-card shadow="never" class="centercard-card">
        <el-table
          :height="PagesIsMore ? 'calc(100vh - 24.3rem)' : 'calc(100vh - 22rem)'"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="MagerTable"
          :data="KeyAccountManager"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @select="dialogCheck"
          v-el-table-infinite-scroll="PageTouchTheBottom"
          infinite-scroll-disabled="infiniteScrollDisabledIs"
          v-loading="PageTableLoading"
        >
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column
            prop="managerName"
            label="大客户经理姓名"
            width="140"
          ></el-table-column>
          <el-table-column prop="shopNameList" label="维护店"> </el-table-column>
          <el-table-column prop="stateText" label="是否启用" width="140">
          </el-table-column>
          <el-table-column prop="empName" label="对应员工" width="140">
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人" width="140">
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期">
          </el-table-column>
          <el-table-column prop="updateUserName" label="修改人">
          </el-table-column>
          <el-table-column prop="updateTime" label="最后修改时间">
          </el-table-column>
        </el-table>
        <el-alert
          v-if="PagesIsMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
    <!-- 创建会员弹出框 -->
    <div class="establish">
      <el-dialog
      @close="guanbi"
      :close-on-click-modal="false"
        width="50%"
        title="客户经理-创建"
        :visible.sync="dialogFormVisible"
      >
       <el-form
          size="mini"
          ref="ConfirmCreationRefs"
          label-width="80px"
          :rules="dialogFormVisibleRlues"
          :model="establishList"
        >
       <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="维护店" prop="checkListSelect">
            <el-tree
              :data="establishList.checkList"
              :props="defaultProps"        
              node-key="id"
              :check-strictly="false"
              default-expand-all
              show-checkbox
              :highlight-current='true' 
              ref="tree1">
            </el-tree>

            <!-- <el-checkbox-group v-model="establishList.checkListSelect">
              <el-checkbox
                :label="item.lable"
                :value="item.id"
                v-for="(item, index) in establishList.checkList"
                :key="index"
              >
              </el-checkbox>
            </el-checkbox-group> -->
          </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="大客户经理名称" prop="name">
            <el-input v-model="establishList.name"></el-input>
          </el-form-item>
          <el-form-item label="客户经理级别">
              <el-select style="width:100%;" v-model="establishList.accountLvlID">
                      <el-option value="" label="无"></el-option>
                      <el-option v-for="item in lists" :key="item.accLevel" :value="item.accountLvlID" :label="item.accountName"></el-option>
                </el-select>
              </el-form-item>
         
          <el-form-item label="个人展示图片" prop="imageUrl">
            <div style="margin-top: 15px">
              <span style="color: #b8ae22;"
                >说明：格式JPG；尺寸:xx*xx；大小xxMB</span
              >
            </div>
            <el-upload
              class="updelu-image"
              ref="upload"
              action="/api/uploadImg"
              :limit="limitSize"
              accept="image/*"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="getFile"
            >
              <img
                v-if="establishList.imageUrl"
                :src="establishList.imageUrl"
                class="avatar"
                @click="removerImage"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="对应员工" prop="staff">
            <div class="flex-between">
              <el-input v-model="establishList.staff" disabled> </el-input>
              <el-button
                @click="CreateSelection"
                style="
                  width: 100px;
                  margin-left: 10px;
                  background-color: #cccccc;
                  color: #4d4d4d;
                "
                size="small"
                >选择</el-button
              >
            </div>
          </el-form-item>
            </el-col>
           </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ConfirmCreation">保存</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 选择弹窗 -->
      <div>
        <el-dialog width="40%" title="选择人员" :visible.sync="innerVisible">
          <el-form
            v-model="PagesStaff"
            size="mini"
            :label-position="labelPosition"
            label-width="80px"
          >
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="员工编号">
                  <el-input v-model="PagesStaff.number"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="员工姓名">
                  <el-input v-model="PagesStaff.name"> </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="员工类型">
                  <el-select
                    style="width: 100%"
                    v-model="PagesStaff.employeeTypeId"
                  >
                    <el-option
                      v-for="item in EmployeeType"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="门店编号\名称">
                  <el-input v-model="PagesStaff.storeName"> </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <div class="search-div">
                <el-button
                  style="
                    width: 100px;
                    margin-left: 10px;
                    background-color: #f1f1f1;
                    color: #b6b388;
                  "
                  size="small"
                  icon="el-icon-search"
                  @click="searchhy"
                  >查询</el-button
                >
              </div>
            </el-row>
          </el-form>
          <div style="width: 100%; margin-top: 10px">
            <el-table
              height="300"
              ref="MagerTableStaff"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              :data="StaffList"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChangeStaff"
              @select="dialogCheckStaff"
              v-el-table-infinite-scroll="PageTouchTheBottomStaff"
              infinite-scroll-disabled="infiniteScrollDisabledIsStaff"
              v-loading="PageTableLoadingStaff"
            >
              <el-table-column label width="60" type="index"> </el-table-column>
              <el-table-column type="selection" width="45"> </el-table-column>
              <el-table-column
                prop="empCode"
                label="用户编号"
              ></el-table-column>
              <el-table-column prop="empName" label="姓名"> </el-table-column>
              <el-table-column prop="empKindText" label="员工类型">
              </el-table-column>
            </el-table>
            <el-alert
              v-if="PagesIsMoreStaff"
              title="没有更多数据了!"
              type="warning"
              center
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="ButConfitinnerVisible">确 定</el-button>
            <el-button @click="innerVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 修改会员弹出窗 -->
    <div class="modification">
      <el-dialog
        width="50%"
        title="大客户经理-修改"
        :visible.sync="modificationFormVisible"
      >
        <el-form
          size="mini"
          ref="UpdateViewDetailedDataRefs"
          label-width="130px"
          :rules="UpdateViewDetailedDataRlues"
          :model="UpdateViewDetailedData"
        >
           <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="维护店" prop="regionsSelect">
                <el-tree
                :default-checked-keys="UpdateViewDetailedData.regionsSelect"
                  :data="establishList.checkList"
                  :props="defaultProps"        
                  node-key="id"
                  :check-strictly="false"
                  default-expand-all
                  show-checkbox
                  :highlight-current='true' 
                  ref="tree2">
                </el-tree>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                 <el-form-item label="大客户经理名称" prop="managerName">
            <el-input v-model="UpdateViewDetailedData.managerName"></el-input>
          </el-form-item>
           <el-form-item label="客户经理级别">
              <el-select style="width:100%;" v-model="UpdateViewDetailedData.accountLvlID">
                      <el-option value="" label="无"></el-option>
                      <el-option v-for="item in lists" :key="item.accLevel" :value="item.accountLvlID" :label="item.accountName"></el-option>
                </el-select>
              </el-form-item>
          <!-- <el-form-item label="维护区域" prop="regionsSelect">
            <el-checkbox-group v-model="UpdateViewDetailedData.regionsSelect">
              <el-checkbox
                :checked="item.checked"
                :label="item.regionName"
                :value="item.regionID"
                v-for="(item, index) in UpdateViewDetailedData.regions"
                :key="index"
              >
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
          <el-form-item label="个人展示图片" prop="qrcode">
            <div style="margin-top: 15px">
              <span style="color: #b8ae22"
                >说明：格式JPG；尺寸:xx*xx；大小xxMB</span
              >
            </div>
            <el-upload
              class="updelu-image"
              ref="upload"
              action="/api/uploadImg"
              :limit="limitSize"
              accept="image/*"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="UpgetFile"
            >
              <img
                v-if="UpdateViewDetailedData.qrcode"
                :src="UpdateViewDetailedData.qrcode"
                class="avatar"
                @click="removerImage"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="对应员工" prop="empName">
            <div class="flex-between">
              <el-input v-model="UpdateViewDetailedData.empName" disabled>
              </el-input>
              <el-button
                @click="ModifySelection"
                style="
                  width: 100px;
                  margin-left: 10px;
                  background-color: #cccccc;
                  color: #4d4d4d;
                "
                size="small"
                >选择</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="状态">
            <el-checkbox
              class="State-flex-checkbox"
              :checked="UpdateViewDetailedData.state"
              v-model="UpdateViewDetailedData.state"
            ></el-checkbox>
          </el-form-item>
              </el-col>
         </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button style="width: 120px" @click="ModifyAndSave"
            >保存</el-button
          >
          <el-button
            style="width: 120px"
            @click="modificationFormVisible = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div class="look">
      <el-dialog
        width="50%"
        title="大客户经理-查看"
        :visible.sync="lookVisible"
      >
        <el-form size="mini" label-width="130px">
            <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="维护店" >
                <el-tree
                :default-checked-keys="ruleForm.type"
                  :data="establishList.checkList"
                  :props="defaultProps1"        
                  node-key="id"
                  :check-strictly="false"
                  default-expand-all
                  show-checkbox
                  :highlight-current='true' 
                  ref="tree3">
                </el-tree>
                </el-form-item>
              <!-- 
                <el-form-item label="维护区域">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox
                :label="item.regionName"
                :checked="item.checked"
                disabled
                v-for="(item, index) in ViewDetailedData.regions"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
               -->
            </el-col>
            <el-col :span="12">
               <el-form-item label="大客户经理名称">
            <el-input
              v-model="ViewDetailedData.managerName"
              readonly
            ></el-input>
          </el-form-item>
            <!-- </el-col>
            <el-col> -->
          <el-form-item label="大客户经理名称">
            <el-input
              v-model="ViewDetailedData.managerName"
              readonly
            ></el-input>
          </el-form-item>
           <el-form-item label="客户经理级别">
              <el-select style="width:100%;" v-model="ViewDetailedData.accountLvlID" disabled>
                 <el-option value="" label="无"></el-option>
                <el-option v-for="item in lists" :key="item.accLevel" :value="item.accountLvlID" :label="item.accountName"></el-option>
                </el-select>
              </el-form-item>
           <el-form-item label="个人展示图片">
            <div style="margin-top: 20px">
              <el-image
                style="width: 100px; height: 100px"
                :src="ViewDetailedData.qrcode"
                :preview-src-list="[ViewDetailedData.qrcode]"
              ></el-image>
            </div>
          </el-form-item>
          <el-form-item label="对应员工">
            <el-input v-model="ViewDetailedData.empName" readonly> </el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-checkbox
              class="State-flex-checkbox"
              :checked="ViewDetailedData.state"
              disabled
            ></el-checkbox>
          </el-form-item>
           <el-form-item label="创建人">
            <el-input v-model="ViewDetailedData.createUserName" readonly>
            </el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="ViewDetailedData.createTime" readonly>
            </el-input>
          </el-form-item>
          <el-form-item label="最后修改人">
            <el-input v-model="ViewDetailedData.updateUserName" readonly>
            </el-input>
          </el-form-item>
          <el-form-item label="最后修改时间">
            <el-input v-model="ViewDetailedData.updateTime" readonly>
            </el-input>
          </el-form-item>
            </el-col>
          <!-- <el-form-item label="维护区域">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox
                :label="item.regionName"
                :checked="item.checked"
                disabled
                v-for="(item, index) in ViewDetailedData.regions"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
         
         
            </el-row>
        </el-form>
      
        <div slot="footer" class="dialog-footer">
          <el-button @click="lookVisible = false">确 认</el-button>
          <el-button @click="lookVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除会员确认取消对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>会员信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="comfitDelete">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  GetShopQueryRegion,
  managerPage,
  uploadImg,
  selectEmpList,
  managerInsert,
  managerDelete,
  managerQuery,
  managerUpdate,
} from "@/api/viewMemberModule";
import { getcpyNo } from "@/utils/auth";
import { mapState } from "vuex";
// import { UploadPictures } from "@/utils/constant";
import { accountmnglvlSelectList } from "@/api/user";
export default {
  data() {
    return {
      PagesStaff: {
        //选择人员列表参数
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        number: "",
        name: "",
        employeeTypeId: "",
        storeName: "",
      },
      EmployeeType: [
        //选择人员 员工类型
        { id: "", value: "全部" },
        { id: "1", value: "门店员工" },
        { id: "2", value: "区域员工" },
        { id: "3", value: "公司员工" },
      ],
      stateList:[
        { id: "", value: "全部" },
        { id: "0", value: "有效" },
        { id: "1", value: "无效" },
      ],
      limitSize: 1,
      establishList: {
        name: "",
        checkList: [],
        checkListSelect: [],
        imageUrl: "",
        staff: "",
        empID: "",
        accountLvlID:""
      },
      dialogFormVisibleRlues: {
        name: [{ required: true, message: "请输入大客户经理名称" }],
        checkListSelect: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个维护区域",
            trigger: "change",
          },
        ],
        imageUrl: [
          { required: true, message: "请上传展示图片", trigger: "change" },
        ],
        staff: [{ required: true, message: "请选择对应员工", trigger: "blur" }],
      },
      loading: false,
      SelectChang: {},
      SelectChangStaff: {},
      PageTableLoadingStaff: false,
      PageTableLoading: false,
      Pages: {
        //大客户经理列表请求参数
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        search: "",
        state:""
      },
      labelPosition: "top",
      // 弹窗表单
      ruleForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      lookVisible: false,
      innerVisible: false,
      dialogFormVisible: false,

      modificationFormVisible: false,
      deleteFormVisible: false,
      formInline: {
        user: "",
        region: "",
      },
      // 内层弹窗数据  员工列表
      StaffList: [],
      KeyAccountManager: [], //大客户经理
      MaintenanceAreaSelect: "", //选择的维护区域
      MaintenanceArea: [], //维护区域
      PCOrAppRadio: "1",
      ViewDetailedData: {}, //大客户详情 查询数据
      UpdateViewDetailedData: {}, //大客户详情 修改数据
      UpdateViewDetailedDataRlues: {
        managerName: [{ required: true, message: "请输入大客户经理名称" }],
        regionsSelect: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个维护区域",
            trigger: "change",
          },
        ],
        qrcode: [
          { required: true, message: "请上传展示图片", trigger: "change" },
        ],
        empName: [
          { required: true, message: "请选择对应员工", trigger: "blur" },
        ],
      },
      IsUpdateSelect: 0, //0:修改选择员工  1:创建选择员工
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        look: false,
        delete: false,
      },
      lists:[],
      defaultProps: {children: 'chlidren',label: 'lable'},
      defaultProps1: {
        children: 'chlidren',
        label: 'lable',
        disabled: this.isdisabledFn,
        },
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
      token: (state) => state.user.token,
    }),
    PagesIsMoreStaff() {
      return this.PagesStaff.pageNo >= this.PagesStaff.pagesTotal;
    },
    PagesIsMore() {
      return this.Pages.pageNo >= this.Pages.pagesTotal;
    },
    infiniteScrollDisabledIsStaff() {
      return this.PageTableLoadingStaff || this.PagesIsMoreStaff;
    },
    infiniteScrollDisabledIs() {
      return this.PageTableLoading || this.PagesIsMore;
    },
  },
  created() {
    this.RmanagerPage(); //大客户经理列表
    this.RGetShopQueryRegion1(); //所有区域
    this.RGetShopQueryRegion2(); //所有区域
    this.RselectEmpList(); //员工列表
    this.getaccountmnglvlSelectList();  //客户经理下拉框
    let Manager = JSON.parse(localStorage.getItem("Manager"));
    console.log(Manager);
    for (let i = 0; i < Manager.length; i++) {
      if (Manager[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Manager[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Manager[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (Manager[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (Manager[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
    }
  },
  methods: {
    isdisabledFn() {
      return true
    },
    guanbi(){
      this.$refs.ConfirmCreationRefs.resetFields();
    },
    create(){
      this.dialogFormVisible = true
       this.$nextTick(function() {
        this.$refs.tree1.setCheckedKeys([])
      })
       this.establishList.checkListSelect=[]
    },
    CreateSelection() {
      //创建选择员工
      this.IsUpdateSelect = 1;
      this.innerVisible = true;
    },
    ModifySelection() {
      //修改选择员工
      this.IsUpdateSelect = 0;
       this.$nextTick(function() {
        this.$refs.tree2.setCheckedKeys([])
      })
      this.UpdateViewDetailedData.regionsSelect=[]
      this.innerVisible = true;
    },
    ModifyAndSave() {
      //修改保存
      this.UpdateViewDetailedData.regionsSelect=this.$refs.tree2.getCheckedKeys(true)
      console.log(this.UpdateViewDetailedData.regionsSelect,'this.UpdateViewDetailedData.regionsSelect');
      this.$refs.UpdateViewDetailedDataRefs.validate((valid) => {
        if (valid) {
          let regionIDs = [];
          regionIDs=[...new Set( this.UpdateViewDetailedData.regionsSelect)]
          let state = this.UpdateViewDetailedData.state ? 0 : 1;
          // this.UpdateViewDetailedData.regionsSelect.forEach((item) => {

          //   this.UpdateViewDetailedData.regions.forEach((myitem) => {
          //     if (item == myitem.regionName) {
          //       regionIDs.push(myitem.regionID);
          //     }
          //   });
          // });
          let data = require("qs").stringify({
            cpyNo: getcpyNo,
            QRCode: this.UpdateViewDetailedData.qrcode,
            empID: this.UpdateViewDetailedData.empID,
            managerID: this.UpdateViewDetailedData.managerID,
            managerName: this.UpdateViewDetailedData.managerName,
            shopIDs: regionIDs.join(","),
            state: state,
            accountLvlID:this.UpdateViewDetailedData.accountLvlID,
          });
          managerUpdate(data).then((res) => {
            if (res.success) {
              this.modificationFormVisible = false;
              this.$message.success("修改成功");
              this.KeyAccountManager = [];
              this.Pages.total = 0;
              this.Pages.pageNo = 1;
              this.RmanagerPage();
            } else {
              this.$message.error("修改失败!");
            }
          });
          this.UpdateViewDetailedData.regionsSelect=[]
        } else {
          return false;
        }
      });
    },
    modify() {
      //修改
     
      this.UpdateViewDetailedData.regionsSelect=[]
      this.UpdateViewDetailedData = {};
      this.$nextTick(function() {
        this.$refs.tree2.setCheckedKeys([])
      })
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请选择对应数据再进行修改",
          type: "warning",
        });
      } else {
        
        let data = require("qs").stringify({
          managerID: this.SelectChang.managerID,
        });
        managerQuery(data).then((res) => {
          if (res.success) {
            res.data.state = res.data.state == 0 ? true : false;
            res.data.createTime = this.renderTime(res.data.createTime);
            res.data.updateTime = this.renderTime(res.data.updateTime);
            res.data.regionsSelect = [];
            this.UpdateViewDetailedData = res.data;
            if(res.data.accountLvlID==null) this.UpdateViewDetailedData.accountLvlID=""
            this.UpdateViewDetailedData.shopList.forEach((item)=>{
              this.UpdateViewDetailedData.regionsSelect.push(item.shopID)
            })
            this.modificationFormVisible = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    comfitDelete() {
      let data = require("qs").stringify({
        managerID: this.SelectChang.managerID,
      });
      managerDelete(data).then((res) => {
        if (res.success) {
          this.deleteFormVisible = false;
          this.$message.success("删除成功");
          this.KeyAccountManager = [];
          this.Pages.total = 0;
          this.Pages.pageNo = 1;
          this.RmanagerPage();
        } else {
          this.$message.error("删除失败!");
        }
      });
    },
    Delete() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请选择对应数据再进行删除",
          type: "warning",
        });
      } else {
        this.deleteFormVisible = true;
      }
    },
    lookOver() {
      this.lookVisible = true;
       this.$nextTick(function() {
        this.$refs.tree3.setCheckedKeys([])
      })
      this.ruleForm.type=[]
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请选择对应数据再进行查看",
          type: "warning",
        });
      } else {
        let data = require("qs").stringify({
          managerID: this.SelectChang.managerID,
        });
        managerQuery(data).then((res) => {
          if (res.success) {
            res.data.state = res.data.state == 0 ? true : false;
            res.data.createTime = this.renderTime(res.data.createTime);
            res.data.updateTime = this.renderTime(res.data.updateTime);
            this.ViewDetailedData = res.data;
            if(res.data.accountLvlID==null)  this.ViewDetailedData.accountLvlID="无"
              this.ViewDetailedData.shopList.forEach((item)=>{
               this.ruleForm.type.push(item.shopID)
            })
            // this.lookVisible = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    searchhy() {
      this.PagesStaff.pagesTotal = 0;
      this.PagesStaff.pageNo = 1;
      this.StaffList = [];
      this.RselectEmpList();
    },
    ButConfitinnerVisible() {
      if (Object.keys(this.SelectChangStaff).length < 2) {
        this.$message({
          message: "请勾选人员",
          type: "warning",
        });
      } else {
        if (this.IsUpdateSelect == 1) {
          this.establishList.staff = this.SelectChangStaff.empName;
          this.establishList.empID = this.SelectChangStaff.empID;
        } else if (this.IsUpdateSelect == 0) {
          this.UpdateViewDetailedData.empID = this.SelectChangStaff.empID;
          this.UpdateViewDetailedData.empName = this.SelectChangStaff.empName;
        }
        this.innerVisible = false;
      }
    },
    ReturnempKindText(index) {
      let text = "";
      switch (index) {
        case 1:
          text = "门店员工";
          break;
        case 2:
          text = "区域员工";
          break;
        case 3:
          text = "公司员工";
          break;
      }
      return text;
    },
    RselectEmpList() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        pageSize: this.PagesStaff.pageSize,
        pageNo: this.PagesStaff.pageNo,
        empCode: this.PagesStaff.number,
        empKind: this.PagesStaff.employeeTypeId,
        shopNameOrCode: this.PagesStaff.storeName,
        empName: this.PagesStaff.name,
      });
      selectEmpList(data).then((res) => {
        if (res.success) {
          res.data.list.forEach((item) => {
            item.empKindText = this.ReturnempKindText(parseInt(item.empKind));
          });
          this.PagesStaff.total = res.data.total;
          this.StaffList = this.StaffList.concat(res.data.list);
          this.PagesStaff.pagesTotal = res.data.pages;
          this.PageTableLoadingStaff = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    ConfirmCreation() {
      this.establishList.checkListSelect=this.$refs.tree1.getCheckedKeys(true)
      // console.log(this.$refs.tree.getCheckedKeys(),'this.$refs.tree.getCheckedKeys');
      this.$refs.ConfirmCreationRefs.validate((valid) => {
        if (valid) {
          let regionIDs = [];
          regionIDs=[...new Set(this.establishList.checkListSelect)]
          // console.log(regionIDs,'regionIDs');
          // this.establishList.checkListSelect.forEach((item) => {
          //   this.MaintenanceArea.forEach((myitem) => {
          //     if (item == myitem.lable) {
          //       regionIDs.push(myitem.id);
          //     }
          //   });
          // });
          let data = require("qs").stringify({
            cpyNo: getcpyNo,
            QRCode: this.establishList.imageUrl,
            empID: this.establishList.empID,
            managerName: this.establishList.name,
            accountLvlID:this.establishList.accountLvlID?this.establishList.accountLvlID:"",
            shopIDs: regionIDs.join(","),
          });
          managerInsert(data).then((res) => {
            if (res.success) {
              this.dialogFormVisible = false;
              this.$message.success("添加成功");
              this.KeyAccountManager = [];
              this.Pages.total = 0;
              this.Pages.pageNo = 1;
              this.RmanagerPage();
            } else {
              this.$message.error("上传图片失败!");
            }
          });
        } else {
          return false;
        }
      });
    },
    removerImage() {
      this.establishList.imageUrl = "";
      this.$refs.upload.clearFiles();
    },
    UpgetFile(options) {
      //修改上传图片
      const formData = new FormData();
      formData.append("file", options.file);
      uploadImg(formData).then((res) => {
        if (res.success) {
          this.UpdateViewDetailedData.qrcode = res.data;
          this.$message.success("上传成功！");
        } else {
          this.$message.error("上传图片失败!");
        }
      });
    },
    getFile(options) {
      //创建上传图片
      const formData = new FormData();
      formData.append("file", options.file);
      uploadImg(formData).then((res) => {
        if (res.success) {
          this.establishList.imageUrl = res.data;
          this.$message.success("上传成功！");
        } else {
          this.$message.error("上传图片失败!");
        }
      });
    },
    beforeAvatarUpload(file) {
      //过滤图片
      const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
      return isJPG;
    },
    PageTouchTheBottomStaff() {
      this.PageTableLoadingStaff = true;
      setTimeout(() => {
        this.PagesStaff.pageNo += 1;
        this.RselectEmpList();
      }, 200);
    },
    PageTouchTheBottom() {
      this.PageTableLoading = true;
      setTimeout(() => {
        this.Pages.pageNo += 1;
        this.RmanagerPage();
      }, 200);
    },
    handleSelectionChangeStaff(e) {
      if (e.length > 0) {
        this.SelectChangStaff = e[e.length - 1];
      } else {
        this.SelectChangStaff = {};
      }
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
    },
    dialogCheckStaff(selection, row) {
      this.$refs.MagerTableStaff.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChangStaff = row;
        this.$refs.MagerTableStaff.toggleRowSelection(row, true);
      }
    },
    dialogCheck(selection, row) {
      this.$refs.MagerTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.MagerTable.toggleRowSelection(row, true);
      }
    },
    RmanagerPage(type) {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        pageNo: this.Pages.pageNo,
        pageSize: this.Pages.pageSize,
        managerName: this.Pages.search,
        shopID: this.MaintenanceAreaSelect,
        state:this.Pages.state
      });
      managerPage(data).then((res) => {
        if (res.success) {
          res.data.list.forEach((item) => {
            item.stateText =
              item.state == 0 ? "启用" : item.state == 1 ? "禁用" : "";
            item.createTime = this.renderTime(item.createTime);
            item.updateTime = this.renderTime(item.updateTime);
            if (item.shopNameList && item.shopNameList.length > 0) {
              item.shopNameList = item.shopNameList.join(",");
            }
          });
          this.Pages.total = res.data.total;
          if (type) {
            this.KeyAccountManager = [];
          }
          this.KeyAccountManager = this.KeyAccountManager.concat(res.data.list);
          this.Pages.pagesTotal = res.data.pages;
          this.PageTableLoading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    RGetShopQueryRegion1() {
      GetShopQueryRegion().then((res) => {
        if (res.success) {
          this.MaintenanceArea.push({
            id: "",
            lable: "全部",
          });
          let arr=[]
          res.data.forEach((item)=>{
            if(item.chlidren){
              item.chlidren.forEach((lineItem)=>{
                arr.push(lineItem)
              })
            }
          })
          this.MaintenanceArea = this.MaintenanceArea.concat(arr);
        }
      });
    },
     RGetShopQueryRegion2() {
      GetShopQueryRegion().then((res) => {
        if (res.success) {
          this.establishList.checkList = res.data;
           this.establishList.checkList.forEach((item)=>{
            item.id=`index${item.id}`
           })
        }
      });
    },
    Query() {
      this.KeyAccountManager = [];
      this.Pages.total = 0;
      this.Pages.pageNo = 1;
      this.RmanagerPage(true);
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
     getaccountmnglvlSelectList(){
     accountmnglvlSelectList().then((res)=>{
      this.lists=res.data
     })
    }
  },
};
</script>
<style lang="scss" scoped>
.State-flex-checkbox {
  margin-top: 6px;
}
.search-div {
  padding-right: 25px;
  display: flex;
  justify-content: flex-end;
}
.updelu-image:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.updelu-image {
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  line-height: 80px;
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border: 1px solid #cccccc;
}
.pages--top-flex {
  display: flex;
  flex-direction: column;
}
.manager-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.centercard-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}
.centercard {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.searchform {
  margin-top: 20px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }

  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  // 创建弹窗样式
  .establish {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-dialog__body {
      padding: 20px 60px;
    }
    .el-input__inner {
      //   width: 300px;
    }
    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__active-bar {
      height: 0;
    }
    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 修改弹窗样式
  .modification {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-dialog__body {
      padding: 20px 60px;
    }
    .el-input__inner {
      //   width: 300px;
    }
    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__active-bar {
      height: 0;
    }
    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 查看弹窗样式
  .look {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-dialog__body {
      padding: 20px 60px;
    }
    .el-input__inner {
      //   width: 300px;
    }
    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__active-bar {
      height: 0;
    }
    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }

  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
